// extracted by mini-css-extract-plugin
module.exports =  {"seller-details":"iNGSCwY","sellerDetails":"iNGSCwY","seller-name":"MWaR0tc","sellerName":"MWaR0tc","badge":"Uf97K78","promoted-gig-text":"_xjBV7a","promotedGigText":"_xjBV7a"};